import React from "react";
import { useTranslation } from "react-i18next";
import Constant from "../../constraints/constant.json";
import { LegalList, LegalPage, LegalSection, LegalSubheading, legalLinkClass } from "./LegalLayout";

const colon = "after:content-[':'] after:ml-0.5";

export function PrivacyPolicy() {
  const { t } = useTranslation();

  const mail = (
    <a className={legalLinkClass} href={"mailto:" + "dataprotection@logitgroup.com"}>
      {Constant.POLICY_LOGITGROUP}
    </a>
  );

  const toc = [
    { id: "pp-introduction", label: t("page.policy.Introduction") },
    { id: "pp-collection", label: t("page.policy.Collection") },
    { id: "pp-data", label: t("page.policy.Data") },
    { id: "pp-consent", label: t("page.policy.Consent") },
    { id: "pp-processing", label: t("page.policy.Datas") },
    { id: "pp-children", label: t("page.policy.Children") },
    { id: "pp-sharing", label: t("page.policy.Sharing") },
    { id: "pp-security", label: t("page.policy.Security") },
    { id: "pp-retention", label: t("page.policy.Retention") },
    { id: "pp-links", label: t("page.policy.Links") },
    { id: "pp-rights", label: t("page.policy.Rights") },
    { id: "pp-disclosures", label: t("page.policy.Disclosures") },
    { id: "pp-california", label: t("page.policy.California") },
    { id: "pp-changes", label: t("page.policy.changepolicy") },
    { id: "pp-contact", label: t("page.policy.Contactus") },
  ];

  return (
    <LegalPage id="privacy-policy" titleTestId="Privacy Policy" title={t("page.policy.Privacy")} toc={toc}>
      <LegalSection id="pp-introduction" title={t("page.policy.Introduction")}>
        <LegalSubheading>{t("page.policy.Effective")}</LegalSubheading>
        <p>{t("page.policy.logitLine")}</p>
        <p>{t("page.policy.thirdLine")}</p>
        <p>{t("page.policy.fourthLine")}</p>
        <p>{t("page.policy.fifthLine")}</p>
        <p>{t("page.policy.sixthLine")}</p>
        <p>{t("page.policy.seventhLine")}</p>
        <p>{t("page.policy.eighthLine")}</p>
        <p>{t("page.policy.ninethLine")}</p>
      </LegalSection>

      <LegalSection id="pp-collection" title={t("page.policy.Collection")}>
        <p>{t("page.policy.Logit")}</p>
        <LegalList
          items={[
            t("page.policy.online"),
            t("page.policy.may"),
            t("page.policy.personal"),
            t("page.policy.through"),
            <>
              {t("page.policy.identifiable")}
              <ul className="pl-5 mt-2 space-y-2 list-[circle] marker:text-ink-4">
                <li className="pl-1">{t("page.policy.identifiable1")}</li>
                <li className="pl-1">{t("page.policy.identifiable2")}</li>
              </ul>
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection id="pp-data" title={t("page.policy.Data")}>
        <p>{t("page.policy.electronically")}</p>
        <p>{t("page.policy.personals")}</p>
        <p>{t("page.policy.Group")}</p>
        <p className={colon}>{t("page.policy.collects")}</p>
        <LegalList
          items={[
            t("page.plicy.opinion"),
            t("page.plicy.incentives"),
            t("page.plicy.verify"),
            t("page.plicy.suitability"),
            t("page.plicy.account"),
            t("page.plicy.identity"),
            t("page.plicy.personalize"),
            t("page.plicy.relevant"),
            t("page.plicy.respond"),
            t("page.plicy.deliver"),
            t("page.plicy.analytics"),
            t("page.plicy.browsing"),
            t("page.policy.offerings"),
            t("page.policy.aggregated"),
            t("page.policy.meet"),
          ]}
        />
      </LegalSection>

      <LegalSection id="pp-consent" title={t("page.policy.Consent")}>
        <p>{t("page.policy.reasonably")}</p>
        <p>{t("page.policy.parties")}</p>
        <p>{t("page.policy.time")}</p>
      </LegalSection>

      <LegalSection id="pp-processing" title={t("page.policy.Datas")}>
        <p>{t("page.policy.processed")}</p>
      </LegalSection>

      <LegalSection id="pp-children" title={t("page.policy.Children")}>
        <p>{t("page.policy.without")}</p>
      </LegalSection>

      <LegalSection id="pp-sharing" title={t("page.policy.Sharing")}>
        <p>{t("page.policy.law")}</p>
        <LegalList
          items={[
            t("page.policy.disclose"),
            t("page.policy.databases"),
            t("page.policy.companies"),
            t("page.policy.judgment"),
            "We will not share mobile contact information with third parties or affiliates for marketing or promotional purposes. Information sharing to subcontractors in support services, such as customer service, is permitted. All other categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.",
          ]}
        />
      </LegalSection>

      <LegalSection id="pp-security" title={t("page.policy.Security")}>
        <p>{t("page.policy.governance")}</p>
        <p>{t("page.policy.require")}</p>
        <p>{t("page.policy.confidentiality")}</p>
      </LegalSection>

      <LegalSection id="pp-retention" title={t("page.policy.Retention")}>
        <p>{t("page.policy.sufficient")}</p>
        <p>{t("page.policy.retained")}</p>
        <p>{t("page.policy.further")}</p>
      </LegalSection>

      <LegalSection id="pp-links" title={t("page.policy.Links")}>
        <p>{t("page.policy.responsibility")}</p>
      </LegalSection>

      <LegalSection id="pp-rights" title={t("page.policy.Rights")}>
        <p>{t("page.policy.legal")}</p>
        <p>{t("page.policy.organizations")}</p>
        <p>{t("page.policy.GDPR")}</p>
        <p className={colon}>{t("page.policy.following")}</p>
        <div className="p-5 space-y-3 border rounded-lg sm:p-6 bg-surface border-line">
          <LegalSubheading>{t("page.policy.be")}</LegalSubheading>
          <p>{t("page.policy.keep")}</p>
          <LegalSubheading>{t("page.policy.access")}</LegalSubheading>
          <p>
            {t("page.policy.contact")} {mail} {t("page.policy.holds")}
          </p>
          <LegalSubheading>{t("page.policy.rectification")}</LegalSubheading>
          <p>{t("page.policy.inaccurate")}</p>
          <LegalSubheading>{t("page.policy.erasure")}</LegalSubheading>
          <p>{t("page.policy.us")}</p>
          <LegalSubheading>{t("page.policy.restrict")}</LegalSubheading>
          <p>{t("page.policy.datas")}</p>
          <LegalSubheading>{t("page.policy.rightto")}</LegalSubheading>
          <p>{t("page.policy.services")}</p>
          <LegalSubheading>{t("page.policy.object")}</LegalSubheading>
          <p>{t("page.policy.circumstances")}</p>
          <LegalSubheading>{t("page.policy.lodge")}</LegalSubheading>
          <p>{t("page.policy.which")}</p>
        </div>
      </LegalSection>

      <LegalSection id="pp-disclosures" title={t("page.policy.Disclosures")}>
        <p>{t("page.policy.more")}</p>
        <LegalSubheading>{t("page.policy.know")}</LegalSubheading>
        <LegalList items={[t("page.policy.informed"), t("page.policy.point")]} />
        <LegalSubheading>{t("page.policy.sold")}</LegalSubheading>
        <LegalList items={[t("page.policy.neverBeSold"), t("page.policy.pertain")]} />
        <LegalSubheading>{t("page.policy.personalsi")}</LegalSubheading>
        <p>{t("page.policy.never")}</p>
        <LegalSubheading>{t("page.policy.ones")}</LegalSubheading>
        <p>
          {t("page.policy.pcontact")} {mail} {t("page.policy.wish")}
        </p>
        <LegalSubheading>{t("page.policy.price")}</LegalSubheading>
      </LegalSection>

      <LegalSection id="pp-california" title={t("page.policy.California")}>
        <p className={colon}>{t("page.policy.collected")}</p>
        <LegalList
          items={[
            <>
              <b className={`text-ink ${colon}`}>{t("page.policy.Identifiers")}</b> {t("page.policy.postal")}
            </>,
            <>
              <b className={`text-ink ${colon}`}>{t("page.policy.records")}</b> {t("page.policy.telephone")}
            </>,
            <>
              <b className={`text-ink ${colon}`}>{t("page.policy.Characteristics")}</b> {t("page.policy.religion")}
            </>,
            <>
              <b className={`text-ink ${colon}`}>{t("page.policy.informations")}</b> {t("page.policy.tendencies")}
            </>,
            <>
              <b className={`text-ink ${colon}`}>{t("page.policy.others")}</b> {t("page.policy.history")}
            </>,
            <b key="geo" className="text-ink">{t("page.policy.Geolocation")}</b>,
            <b key="pro" className="text-ink">{t("page.policy.Professional")}</b>,
          ]}
        />
      </LegalSection>

      <LegalSection id="pp-changes" title={t("page.policy.changepolicy")}>
        <p>{t("page.policy.review")}</p>
        <p>{t("page.policy.March")}</p>
      </LegalSection>

      <LegalSection id="pp-contact" title={t("page.policy.Contactus")}>
        <p>{t("page.policy.exercise")}</p>
        <div className="p-5 space-y-2 border rounded-lg sm:p-6 bg-surface border-line">
          <p>
            <b className={`text-ink ${colon}`}>{t("page.policy.byemail")}</b> {mail}
          </p>
          <p>
            <b className={`text-ink ${colon}`}>{t("page.policy.bytele")}</b> {t("page.policy.extension")}
          </p>
          <p>
            <b className={`text-ink ${colon}`}>{t("page.policy.post")}</b>
          </p>
          <address className="not-italic">
            <span className="block">{t("page.policy.Churcher")}</span>
            <span className="block">{t("page.policy.President")}</span>
            <span className="block">{t("page.policy.Mall")}</span>
            <span className="block">{t("page.policy.Toronto")}</span>
          </address>
        </div>
      </LegalSection>
    </LegalPage>
  );
}
